export enum ApplicationHistorySortCriteria {
  Created = "timestamp",
  ModifiedBy = "modifiedBy",
  Type = "eventType",
  Source = "eventSource",
}

export const ApplicationHistorySortCriteriaUtil = {
  parse: (criteria: string): ApplicationHistorySortCriteria => {
    switch (criteria) {
      case "modifiedBy":
        return ApplicationHistorySortCriteria.ModifiedBy;
      case "eventType":
        return ApplicationHistorySortCriteria.Type;
      case "eventSource":
        return ApplicationHistorySortCriteria.Source;
      case "timestamp":
      default:
        return ApplicationHistorySortCriteria.Created;
    }
  },
};
